<page-header
  [title]="constants.strings.giftVouchers"
  [subtitle]="subtitle"
></page-header>

<div class="actions-container">
  <!-- Desktop view -->
  <div class="button-layout" *ngIf="!(isHandset$ | async)">
    <div class="left-button">
      <app-primary-button
        *ngIf="isConnected && isComplete && canManageVouchers"
        [title]="'Redeem Voucher'"
        (tapped)="openRedeemVoucherDialog()"
      ></app-primary-button>

      <app-primary-button
        *ngIf="isConnected && isComplete && canManageVouchers"
        [title]="'Issue Voucher'"
        (tapped)="openIssueVoucherDialog()"
        style="margin-left: 10px"
      ></app-primary-button>
    </div>

    <div class="right-buttons">
      <app-primary-button
        *ngIf="isConnected && canManageVouchers"
        [title]="!isComplete ? 'Complete Stripe Setup' : 'Stripe Dashboard'"
        (tapped)="openStripeDashboard()"
      ></app-primary-button>

      <app-primary-button
        *ngIf="isConnected && isComplete && canManageVouchers"
        [title]="'Microsite'"
        (tapped)="openMicrositeDialog()"
      ></app-primary-button>

      <app-primary-button
        [title]="'Our Fees'"
        (tapped)="openFeesDialog()"
      ></app-primary-button>

      <app-primary-button
        *ngIf="isConnected && isComplete && canManageVouchers"
        [title]="constants.strings.newVoucher"
        (tapped)="createVoucher()"
        [icon]="'add'"
      ></app-primary-button>
    </div>
  </div>

  <!-- Mobile view -->
  <div class="mobile-actions" *ngIf="isHandset$ | async">
    <app-primary-button
      [title]="'Actions'"
      [icon]="'more_vert'"
      [mat-menu-trigger-for]="mobileMenu"
    ></app-primary-button>
  </div>
</div>

<!-- Mobile menu -->
<mat-menu #mobileMenu="matMenu" class="custom-menu">
  <button
    mat-menu-item
    *ngIf="isConnected && isComplete && canManageVouchers"
    (click)="openRedeemVoucherDialog()"
  >
    <span style="text-decoration: none; color: black; font-size: 15px"
      >Redeem Voucher</span
    >
  </button>

  <button
    mat-menu-item
    *ngIf="isConnected && isComplete && canManageVouchers"
    (click)="openIssueVoucherDialog()"
  >
    <span style="text-decoration: none; color: black; font-size: 15px"
      >Issue Voucher</span
    >
  </button>

  <button
    mat-menu-item
    *ngIf="isConnected && canManageVouchers"
    (click)="openStripeDashboard()"
  >
    <span style="text-decoration: none; color: black; font-size: 15px">{{
      !isComplete ? "Complete Stripe Setup" : "Stripe Dashboard"
    }}</span>
  </button>

  <button
    mat-menu-item
    *ngIf="isConnected && canManageVouchers"
    (click)="openMicrositeDialog()"
  >
    <span style="text-decoration: none; color: black; font-size: 15px"
      >Microsite Configuration</span
    >
  </button>

  <button mat-menu-item (click)="openFeesDialog()">
    <span style="text-decoration: none; color: black; font-size: 15px"
      >Our Fees</span
    >
  </button>

  <button
    mat-menu-item
    *ngIf="isConnected && isComplete && canManageVouchers"
    (click)="createVoucher()"
  >
    <span style="text-decoration: none; color: black; font-size: 15px">{{
      constants.strings.newVoucher
    }}</span>
  </button>
</mat-menu>

<div
  class="detail-container"
  id="left"
  style="margin-bottom: 20px"
  *ngIf="!isConnected && !loading"
>
  <div class="stripe-setup-banner">
    <div style="display: flex; align-items: center">
      <b
        >To start creating vouchers, you need to set up your Stripe account
        first.</b
      >
    </div>

    <app-primary-button
      [title]="hasVouchers ? 'Set Up Stripe' : 'Contact Support to Enable'"
      [disabled]="generating || !hasVouchers"
      (tapped)="setupStripe()"
      bgColor="var(--app-timber)"
      color="white"
    ></app-primary-button>
  </div>

  <div class="info-section">
    <div class="benefits">
      <ul>
        <li>Create and manage digital vouchers with your own branding</li>
        <li>Set custom values and expiry dates with ease</li>
        <li>Monitor redemptions and usage in real-time</li>
        <li>
          Automatically deliver vouchers via email — to both users and non-users
        </li>
        <li>Available exclusively on the Growth plan</li>
        <li>
          Sell vouchers from your own website with a branded micro-site
          (Example:
          <a
            href="https://testvouchersite.remyrewards.co.uk/"
            target="_blank"
            rel="noopener noreferrer"
            >Test Site</a
          >)
        </li>
      </ul>

      <h3>Pricing</h3>
      <ul>
        <li>2.5% – 4% fee per voucher purchase</li>
        <li>No monthly costs or hidden fees</li>
        <li>Secure payment processing powered by Stripe</li>
      </ul>
    </div>

    <div class="stripe-powered">
      <img
        src="assets/poweredByStripe.png"
        alt="Powered by Stripe"
        height="35"
      />
    </div>
  </div>
</div>

<div *ngIf="!loading && isConnected">
  <ngx-datatable
    #myTable
    class="material"
    [headerHeight]="45"
    [rows]="vouchers"
    [scrollbarV]="false"
    [scrollbarH]="true"
    [footerHeight]="50"
    [columnMode]="'force'"
    [rowHeight]="48"
    [externalPaging]="true"
    [messages]="{
      emptyMessage:
        isConnected && canManageVouchers
          ? '<a href=https://app.remyrewards.co.uk/voucher>+ Add your first Voucher</a>'
          : 'No vouchers to display',
    }"
    [count]="length"
    [offset]="pageIndex"
    (page)="pageEvent($event)"
    (scroll)="handleScroll()"
    [limit]="pageSize"
    (activate)="rowTappedNGX($event)"
  >
    <ngx-datatable-column
      name=""
      [resizeable]="false"
      [sortable]="false"
      [maxWidth]="80"
      [draggable]="false"
      *ngIf="canManageVouchers"
    >
      <ng-template
        let-row="row"
        let-rowIndex="rowIndex"
        ngx-datatable-cell-template
      >
        <div
          style="display: flex; align-items: center; gap: 2px"
          (click)="$event.stopPropagation()"
        >
          <mat-icon
            class="reorder-icon"
            style="
              cursor: pointer;
              color: var(--app-text-grey);
              font-size: 18px;
              width: 18px;
              height: 18px;
            "
            [matTooltip]="'Move up'"
            [matTooltipShowDelay]="500"
            (click)="moveVoucher(row, rowIndex, 'up')"
            [style.opacity]="rowIndex === 0 ? '0.3' : '1'"
            [style.pointer-events]="rowIndex === 0 ? 'none' : 'auto'"
            >arrow_upward</mat-icon
          >
          <mat-icon
            class="reorder-icon"
            style="
              cursor: pointer;
              color: var(--app-text-grey);
              font-size: 18px;
              width: 18px;
              height: 18px;
            "
            [matTooltip]="'Move down'"
            [matTooltipShowDelay]="500"
            (click)="moveVoucher(row, rowIndex, 'down')"
            [style.opacity]="rowIndex === vouchers.length - 1 ? '0.3' : '1'"
            [style.pointer-events]="
              rowIndex === vouchers.length - 1 ? 'none' : 'auto'
            "
            >arrow_downward</mat-icon
          >
        </div>
      </ng-template>
    </ngx-datatable-column>

    <ngx-datatable-column name="Voucher" [resizeable]="false">
      <ng-template let-row="row" ngx-datatable-cell-template>
        {{ row?.displayAs }}
      </ng-template>
    </ngx-datatable-column>

    <ngx-datatable-column name="Type" [resizeable]="false">
      <ng-template let-row="row" ngx-datatable-cell-template>
        {{ row?.voucherType | titlecase }}
      </ng-template>
    </ngx-datatable-column>

    <ngx-datatable-column name="Value/Cost" [resizeable]="false">
      <ng-template let-row="row" ngx-datatable-cell-template>
        {{ valueString(row) }}
      </ng-template>
    </ngx-datatable-column>

    <!-- <ngx-datatable-column name="Redeemable Value" [resizeable]="false">
      <ng-template let-row="row" ngx-datatable-cell-template>
        {{ row?.value | currency : "GBP" }}
      </ng-template>
    </ngx-datatable-column>

    <ngx-datatable-column name="Cost" [resizeable]="false">
      <ng-template let-row="row" ngx-datatable-cell-template>
        {{ row?.cost | currency : "GBP" }}
      </ng-template>
    </ngx-datatable-column> -->

    <!-- <ngx-datatable-column name="Discount" [resizeable]="false">
      <ng-template let-row="row" ngx-datatable-cell-template>
        <div class="discount-container">
          <span *ngIf="!row?.discount">-</span>

          <div *ngIf="row?.discount">
            <span class="absolute-discount">{{
              row?.discount?.value | currency : "GBP"
            }}</span>
            <span class="percentage-discount" *ngIf="row?.value > 0">
              ({{ row?.discount?.percent | number : "1.0-0" }}%)
            </span>
          </div>
        </div>
      </ng-template>
    </ngx-datatable-column> -->

    <ngx-datatable-column name="Status" [resizeable]="false">
      <ng-template let-row="row" ngx-datatable-cell-template>
        <div id="status-chip" [ngClass]="constants.statusChipClass(row)">
          {{ row?.active ? "Listed" : "Unlisted" }}
        </div>
      </ng-template>
    </ngx-datatable-column>

    <ngx-datatable-column name="Visibility" [resizeable]="false">
      <ng-template let-row="row" ngx-datatable-cell-template>
        {{ row?.visibility?.join(", ") }}
      </ng-template>
    </ngx-datatable-column>

    <ngx-datatable-column
      name="Actions"
      [resizeable]="false"
      *ngIf="canManageVouchers"
    >
      <ng-template let-row="row" ngx-datatable-cell-template>
        <div
          class="actions-icon-container"
          [matTooltip]="'More actions'"
          [matTooltipShowDelay]="500"
          [mat-menu-trigger-for]="menu"
          (click)="$event.stopPropagation()"
          [matMenuTriggerData]="{ voucher: row }"
        >
          <mat-icon>more_horiz</mat-icon>
        </div>
      </ng-template>
    </ngx-datatable-column>
  </ngx-datatable>
</div>

<mat-menu #menu="matMenu" class="custom-menu">
  <ng-template matMenuContent let-voucher="voucher">
    <button
      [disabled]="
        !voucher?.active &&
        voucher?.cost < 10 &&
        voucher?.voucherType === 'fixed'
      "
      [matTooltip]="
        !voucher?.active &&
        voucher?.cost < 10 &&
        voucher?.voucherType === 'fixed'
          ? 'Vouchers must have a minimum cost of £10 to be listed'
          : ''
      "
      [matTooltipShowDelay]="500"
      class="menu-list-item"
      style="border-radius: 5px"
      (click)="
        handleMenuOptionSelection(
          voucher?.active ? deactivateTitle.title : activateTitle.title,
          voucher
        )
      "
      mat-menu-item
    >
      <mat-icon
        fontSet="material-icons-outlined"
        style="
          font-size: 16px;
          vertical-align: middle;
          display: flex;
          align-items: center;
          margin-right: 5px;
        "
        >{{
          voucher?.active ? deactivateTitle.icon : activateTitle.icon
        }}</mat-icon
      >
      <span class="menu-list-item-label">
        {{
          voucher?.active ? deactivateTitle.title : activateTitle.title
        }}</span
      >
    </button>
  </ng-template>
</mat-menu>

<loader [loading]="loading || generating"></loader>
